import { AdminRO } from '@routellers/types/dist/admin/admin.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = undefined;

type ResponseData = AdminRO[];

export const query: ApiMethodDeclaration<ParamsData, ResponseData> = (params) => ({
    url: '/admins',
    method: 'GET',
    params,
});
